import React from 'react';
import classnames from 'classnames';
import {
  FacebookShareButton,
  LinkedinShareButton,
  TwitterShareButton,
} from 'react-share';
import * as styles from './socials.module.scss';

import Icon from 'components/UI/Icon';

const Shared = ({ text, url, mod }) => (
  <div>
    <ul className={classnames(styles.list, styles[mod])}>
      <li className={classnames(styles.item)}>
        <p className={classnames(styles.link, 'cr-bounce-scal')}>
          <FacebookShareButton url={url} quote={text}>
            <Icon name="social-facebook" />
          </FacebookShareButton>
        </p>
      </li>
      <li className={classnames(styles.item)}>
        <p className={classnames(styles.link, 'cr-bounce-scal')}>
          <LinkedinShareButton url={url} title={text}>
            <Icon name="social-linkedIn" />
          </LinkedinShareButton>
        </p>
      </li>
      <li className={classnames(styles.item)}>
        <p className={classnames(styles.link, 'cr-bounce-scal')}>
          <TwitterShareButton url={url} title={text}>
            <Icon name="social-twitter" />
          </TwitterShareButton>
        </p>
      </li>
    </ul>
  </div>
);

export default Shared;
